import styled from 'styled-components';
import { Container as LayoutContainer } from '../layout/Container';

export const Container = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 50;
  background: rgba(249, 248, 244, 0.95);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  box-shadow: 0 1px 0 #eeedea;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px 0;

  @media (max-width: 768px) {
    padding: 10px 0;
  }
`;

export const NavContainer = styled(LayoutContainer)`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
`;

export const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0;
  cursor: pointer;
  flex-shrink: 0;
`;

export const Logo = styled.img`
  width: 159.88px;
  height: 48px;
  object-fit: contain;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.8;
  }

  @media (max-width: 768px) {
    width: 112px;
    height: auto;
  }
`;
